import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import { EquipeService } from '../equipe/equipe.service';
import { EstadoService } from '../estado/estado.service';
import { listaSexo } from '../shared/listas-parametros';
import { Router } from '@angular/router';

@Component({
  selector: 'ntc-tecnico',
  templateUrl: './tecnico.component.html',
  styleUrls: ['./tecnico.component.css']
})
export class TecnicoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  editOptionsGridTecnico = null;
  colunasGridTecnico = null;
  tecnico = null;
  alturaGrid = null;
  listaEquipe = null;
  listaEstado = null;
  listaStatusSelect =  [
    {Nome: 'Equipe', Status: false},
    {Nome: 'Estado', Status: false}
  ];

  listaSexo = listaSexo;

  constructor(
    @Inject(Http) http: Http,
    private equipeService: EquipeService,
    private estadoService: EstadoService,
    private router: Router
  ) {

    this.tecnico = new CustomStore({
      insert: function (values) {
        values.DtAlteracao = new Date;
        values.DtCadastro = new Date;
        return http.post(`${NTECH_API}/tecnico/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/tecnico/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        values.DtAlteracao = new Date;
        return http.put(`${NTECH_API}/tecnico/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/tecnico/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });

    this.editOptionsGridTecnico = {
      mode: GridConfig.gridMode,
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      popup: {
        title: 'Tecnico',
        showTitle: true
      }
    };
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
    this.listaEquipe = null;

    this.equipeService.getEquipes().subscribe(equipes => {
      this.listaEquipe = equipes;
      this.montaColunasGrid('Equipe');
    });

    this.estadoService.getEstados().subscribe(estados => {
      this.listaEstado = estados;
      this.montaColunasGrid('Estado');
    });
  }

  montaColunasGrid(Grid = null) {

    if (Grid !== null) {
      const foundItem = this.listaStatusSelect.find((fItem) => fItem.Nome === Grid);
      if (foundItem) {
        foundItem.Status = true;
      }
    }

    if (
      (this.listaStatusSelect[0].Status === true ) &&
      (this.listaStatusSelect[1].Status === true)
    ) {

      this.colunasGridTecnico = [
        {
          dataField: 'Id',
          dataType: 'string',
          caption: 'ID',
          editorOptions: { disabled: true }
        },
        {
          dataField: 'Nome',
          dataType: 'string',
          caption: 'Nome',
          validationRules: [{
            type: 'required',
            message: 'Nome é obrigatório.'
          }]
        },
        {
          dataField: 'IdEquipe',
          caption: 'Equipe',
          lookup: {
              dataSource: this.listaEquipe,
              displayExpr: 'DescricaoEquipe',
              valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Equipe é obrigatório.'
          }]
        },
        {
          dataField: 'PlacaCarro',
          dataType: 'string',
          caption: 'Placa do Carro'
        },
        {
          dataField: 'IdEstado',
          caption: 'Estado',
          lookup: {
            dataSource: this.listaEstado,
            displayExpr: 'NomeEstado',
            valueExpr: 'Id'
          }
        },
        {
          dataField: 'Rg',
          dataType: 'string',
          caption: 'RG',
          visible: false
        },
        {
          dataField: 'Cpf',
          dataType: 'string',
          caption: 'CPF',
          validationRules: [{
            type: 'required',
            message: 'CPF é obrigatório.'
          }],
          visible: false
        },
        {
          dataField: 'DtNascimento',
          dataType: 'date',
          caption: 'Data de Nascimento',
          validationRules: [{
            type: 'required',
            message: 'Data de nascimento é obrigatória.'
          }],
          visible: false
        },
        {
          dataField: 'Sexo',
          dataType: 'string',
          caption: 'Sexo',
          lookup: {
            dataSource: this.listaSexo,
            displayExpr: 'Descricao',
            valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Sexo é obrigatório.'
          }],
          visible: false
        },
      ];
    }
  }

  textoSumario(e) {
    return 'Registros: ' + e.value;
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onContextMenuPreparing(e) {
    if (e.row && e.row.rowType === 'data') {
      //console.log(e.row.data.Nome);

      const thisAux = this;

      e.items = [{
        text: 'Mapa',
        /*
        onItemClick: function () {
          thisAux.router.navigate([`/tecnico/mapa-tecnico/${e.row.data.Id}`]);
        }
        */
        onItemClick: this.goToMapa.bind(this, e)
      }];

    }

  }

  goToMapa(e) {
    this.router.navigate([`/tecnico/mapa-tecnico/${e.row.data.Id}`]);
  }

}



// WEBPACK FOOTER //
// ./src/app/tecnico/tecnico.component.ts